import React from "react";
import { Helmet } from "react-helmet";
import "./Homepage.css";

// Components
import Hero from "./PageComponents/Hero/Hero";
import Pitch from "./PageComponents/Pitch/Pitch";
import Services from "./PageComponents/Services/Services";
import Partners from "./PageComponents/Partners/Partners";
import Consult from "./PageComponents/Consult/Consult";
import OrganizationSchema from "./components/StructuredData/OrganizationSchema";
import OpenGraphMeta from "./components/SEO/OpenGraphMeta";

const Homepage = () => {
	return (
		<main id="main-content">
			<Helmet>
				<title>Kinetx Co | IT Infrastructure Solutions | Miami & NYC</title>
				<meta 
					name="description" 
					content="Professional IT infrastructure solutions for Miami and NYC businesses. WiFi networks, security systems, cloud services, and more. Expert design, installation, and support." 
				/>
				<link rel="canonical" href="https://www.kinetx.co/" />
			</Helmet>
			<OpenGraphMeta
				title="Kinetx Co | IT Infrastructure Solutions | Miami & NYC"
				description="Professional IT infrastructure solutions for Miami and NYC businesses. WiFi networks, security systems, cloud services, and more."
				url="https://www.kinetx.co/"
				type="website"
			/>
			<OrganizationSchema />
			<Hero />
			<Pitch />
			<Services />
			<Partners />
			<Consult color={"homepage"} />
		</main>
	);
};

export default Homepage;
